import { $ } from "@/plug/Axios";

export default {
  /**
   * 夜校考勤
   */
  nightAttendance_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/export", p, c)
  },
  nightAttendance_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/list", p, c)
  },
  nightAttendance_listSimple: {
    /*
     * 列表
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/listSimple", p, c)
  },
  nightAttendance_open: {
    /*
     * 开启考勤
     * classId 班级id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/night/nightAttendance/open", p, c)
  },

  /**
   * 夜校考勤记录
   */
  nightAttendanceRecord_changeStatus: {
    /*
     * 修改状态
     * id 考勤记录id (integer query required)
     * status 状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/night/nightAttendanceRecord/changeStatus", p, c)
  },
  nightAttendanceRecord_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendanceRecord/export", p, c)
  },
  nightAttendanceRecord_exportStudent: {
    /*
     * 导出学生打卡情况列表
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/exportStudent", p, c)
  },
  nightAttendanceRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendanceRecord/list", p, c)
  },
  nightAttendanceRecord_listByStudentId: {
    /*
     * 根据学生id获取考勤列表
     * studentId 学生id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listByStudentId", p, c)
  },
  nightAttendanceRecord_listForClient: {
    /*
     * C端列表
     * classId 课程(班级)id (integer query required)
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listForClient", p, c)
  },
  nightAttendanceRecord_listSimple: {
    /*
     * 简易列表
     * attendanceId 考勤id (integer query required)
     * status 考勤id (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listSimple", p, c)
  },
  nightAttendanceRecord_listStudent: {
    /*
     * 学生打卡情况列表
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listStudent", p, c)
  },

  /**
   * 夜校班级
   */
  nightClass: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * address 上课地点 (string query )
     * adminId 管理员id (integer query )
     * area 区域 (string query )
     * constraints 报名限制 (string query )
     * contact 对接人 (string query )
     * contactPhone 对接人电话 (string query )
     * course 课程 (string query )
     * courseNum 课次 (integer query )
     * courseTime 上课时间 (string query )
     * courseType 课程类型 (string query )
     * coverId 封面资源id (integer query )
     * deadLine 报名截止时间 (string query )
     * fee 费用 (number query )
     * id  (integer query )
     * intro 课程简介 (string query )
     * maxNum 最高开班人数 (integer query )
     * minNum 最低开班人数 (integer query )
     * openOrg 开办方 (string query )
     * openTime 开班时间 (string query )
     * qualifications 报名条件 (string query )
     * studentRequire 学员准备要求 (string query )
     * teacher 教师 (string query )
     * teacherAvatarId 教师头像资源id (integer query )
     * teacherId 老师id (integer query )
     * teacherIntro 师资简介 (string query )
     * teacherPhone 教师电话 (string query )
     * type 类型：春季班、秋季班 (string query )
     * year 年份 (string query )
     */
    post: (p, c) => $.post("/api/cms/night/nightClass", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/night/nightClass", p, c)
  },
  nightClass_checkMaxNum: {
    /*
     * 检查是否超过开班人数上限
     * id 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/checkMaxNum", p, c)
  },
  nightClass_detailsForClient: {
    /*
     * C端详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/detailsForClient", p, c)
  },
  nightClass_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/list", p, c)
  },
  nightClass_listArea: {
    /*
     * 区域列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listArea", p, c)
  },
  nightClass_listCourse: {
    /*
     * 课程列表
     * area 区域 (string query )
     * type 类型 (string query )
     * year 班级年份 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listCourse", p, c)
  },
  nightClass_listCourseType: {
    /*
     * 课程类型列表
     * area 区域 (string query )
     * type 类型 (string query )
     * year 班级年份 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listCourseType", p, c)
  },
  nightClass_listForClient: {
    /*
     * C端列表
     * area 区域 (string query required)
     * courseType 课程类型 (string query )
     * type 类型 (string query required)
     * year 班级年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listForClient", p, c)
  },
  nightClass_listOpenOrg: {
    /*
     * 举办方列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listOpenOrg", p, c)
  },
  nightClass_listSimple: {
    /*
     * 简易列表
     * area 区域 (string query required)
     * type 类型 (string query required)
     * year 班级年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listSimple", p, c)
  },
  nightClass_listSimpleByTeacher: {
    /*
     * 根据讲师获取简易列表
     * area 区域 (string query required)
     * type 类型 (string query required)
     * year 班级年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listSimpleByTeacher", p, c)
  },
  nightClass_listYear: {
    /*
     * 年份列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listYear", p, c)
  },
  nightClass_setCourseType: {
    /*
     * 设置课程列表（调整顺序）
     * courseTypes 课程类型 (array query )
     */
    put: (p, c) => $.put("/api/cms/night/nightClass/setCourseType", p, c)
  },

  /**
   * 夜校学生
   */
  nightStudent: {
    /*
     * 添加
     * classId 班级id (integer query )
     * company 工作单位 (string query )
     * contact 联系方式 (string query )
     * contactAddress 联系地址 (string query )
     * eduLevel 学历层次 (string query )
     * id  (integer query )
     * idCardNo 身份证号 (string query )
     * job 从事岗位 (string query )
     * name 姓名 (string query )
     * newJob 是否为新就业群体 (string query )
     * political 政治面貌 (string query )
     * sex 性别 (string query )
     * spareContact 备用联系方式 (string query )
     * status 状态 (string query )
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent", p, c),

    /*
     * 编辑
     * classId 班级id (integer query )
     * company 工作单位 (string query )
     * contact 联系方式 (string query )
     * contactAddress 联系地址 (string query )
     * eduLevel 学历层次 (string query )
     * id  (integer query )
     * idCardNo 身份证号 (string query )
     * job 从事岗位 (string query )
     * name 姓名 (string query )
     * newJob 是否为新就业群体 (string query )
     * political 政治面貌 (string query )
     * sex 性别 (string query )
     * spareContact 备用联系方式 (string query )
     * status 状态 (string query )
     */
    put: (p, c) => $.put("/api/cms/night/nightStudent", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/night/nightStudent", p, c)
  },
  nightStudent_changeClass: {
    /*
     * 转班(只能转费用相同,且没有开班的学生或者未缴费的学生)
     * classId 班级id (integer query required)
     * ids 学生id (array query required)
     */
    put: (p, c) => $.put("/api/cms/night/nightStudent/changeClass", p, c)
  },
  nightStudent_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/export", p, c)
  },
  nightStudent_feeInfo: {
    /*
     * 费用信息
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/feeInfo", p, c)
  },
  nightStudent_getEnrollInfo: {
    /*
     * 报名情况
     * ableStatus 启用状态 (string query )
     * area 区域 (string query required)
     * type 类型：春季班、秋季班 (string query required)
     * year 年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/getEnrollInfo", p, c)
  },
  nightStudent_getIdByIdCardNo: {
    /*
     * 根据
     * classId 班级id (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/getIdByIdCardNo", p, c)
  },
  nightStudent_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/list", p, c)
  },
  nightStudent_listCourseByIdCardNo: {
    /*
     * 根据身份证查询课程
     * area 区域 (string query required)
     * idCardNo 身份证 (string query required)
     * type 类型：春季班、秋季班 (string query required)
     * year 年份 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightStudent/listCourseByIdCardNo", p, c)
  },
  nightStudent_saveForClient: {
    /*
     * C端添加
     * classId 班级id (integer query )
     * company 工作单位 (string query )
     * contact 联系方式 (string query )
     * contactAddress 联系地址 (string query )
     * eduLevel 学历层次 (string query )
     * id  (integer query )
     * idCardNo 身份证号 (string query )
     * job 从事岗位 (string query )
     * name 姓名 (string query )
     * newJob 是否为新就业群体 (string query )
     * political 政治面貌 (string query )
     * sex 性别 (string query )
     * spareContact 备用联系方式 (string query )
     * status 状态 (string query )
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent/saveForClient", p, c)
  },
  nightStudent_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent/upload", p, c)
  }
};
